export default __webpack_public_path__ + "static/grenette-regular-pro-997639b779dab2b2712d5f8a1df6e783.ttf";